import styled from 'styled-components';
import { body1, body2, colors, fontWeights, spacing } from 'ui/theme';
import { useTranslation } from '../hooks/useTranslation';
import { ContentPicker } from './contentPicker';

const Wrapper = styled.div`
  margin-top: ${spacing.double};
`;

const Title = styled.div`
  ${body1};
  font-weight: ${fontWeights.bold};
  margin-bottom: ${spacing.quarter};
`;

const Subtitle = styled.div`
  ${body2};
  color: ${colors.textSecondary};
  margin-bottom: ${spacing.base};
`;

export const DefaultClauseBlock = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Title>{t('defaultClause.title')}</Title>
      <Subtitle>{t('defaultClause.subtitle')}</Subtitle>
      <ContentPicker />
    </Wrapper>
  );
};
